import { render, staticRenderFns } from "./PublicMarketplaceProductList.vue?vue&type=template&id=1341c0b4&"
import script from "./PublicMarketplaceProductList.vue?vue&type=script&lang=js&"
export * from "./PublicMarketplaceProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports